if (!customElements.get('product-listing')) {
  const plpLoader = `
    <div class="loader flex items-center justify-center">
      <span class="block w-12 h-12">
        <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </span>
    </div>
  `;
  class ProductListing extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      if (!this.isConnected) return;

      if(document.querySelector('[data-hero]')) {
        this.querySelector('[data-listing-title]')?.classList.add('sr-only');
      } else {
        this.querySelector('[data-listing-head]')?.classList.add('max-h-[500px]');
      }
      
      ['change', 'click'].forEach((eventType) => {
        window.addEventListener(eventType, e => {
          const actionEl = e.target.closest('[data-filter-action]');
          if (!actionEl) return;
          
          const productContainer = this.querySelector('[data-product-container]');
          if (!productContainer) return;
          
          const {
            filterAction,
            page
          } = actionEl.dataset;
          
          // keep mobile & desktop inputs in sync with each other
          if (actionEl.checked) {
            document.querySelectorAll(`input[type="checkbox"][data-filter-action="update-filters"]`)
              .forEach((radio) => {
                if (radio.value !== actionEl.value) return;
                radio.setAttribute('checked', true);
              });
          } else {
            document.querySelectorAll(`input[type="checkbox"][data-filter-action="update-filters"]`)
              .forEach((radio) => {
                if (radio.value !== actionEl.value) return;
                radio.removeAttribute('checked', true)
              });
          }
          
          // build searchParams containing all the active input values
          const previousSearchParams = new URLSearchParams(window.location.search);
          let searchParams = new URLSearchParams();
          const activeValues = [...this.querySelectorAll('[data-param-name]')]
            .filter(({ checked }) => checked)
            .map(({ value, dataset: { paramName } }) => ({ paramName, value }));
          
          activeValues.forEach(({ paramName, value }) => {
            if (searchParams.getAll(paramName).find(x => x === value)) return;
            searchParams.append(paramName, value);
          });
          
          if (activeValues.length) {
            this.classList.add('has-filters');
          } else this.classList.remove('has-filters');
          
          
          // preserve search queries on filter
          if (previousSearchParams.get('q')) {
            searchParams.set('q', previousSearchParams.get('q'));
          }
          if (previousSearchParams.get('sort_by')) {
            searchParams.set('sort_by', previousSearchParams.get('sort_by'));
          }
          
          let newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
                    
          switch (filterAction) {
            case 'update-filters':
              newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
              
              productContainer.innerHTML = `
                <intersection-loader 
                  data-url="${newURL}"
                  data-section-id="plp-tiles-listing"
                  class="block w-full py-16 col-span-2 lg:col-span-3 loading relative"
                >${plpLoader}</intersection-loader>
              `;

              this.updateAppliedFiltersSection(newURL); // updated call

              if (window.matchMedia('min-width: 768px').matches) {
                productContainer.scrollIntoView({ behavior: 'smooth' });
              }
            break;
            case 'remove-filter':
              const { paramName, value } = actionEl.dataset;
              if (!paramName || !value) return;

              this.querySelectorAll(`[data-param-name="${paramName}"][value="${value}"]`)
                .forEach(el => el.checked = false);

              const activeValues = [...this.querySelectorAll('[data-param-name]')]
                .filter(el => el.checked)
                .map(({ value, dataset: { paramName } }) => ({ paramName, value }));

              searchParams = new URLSearchParams();
              activeValues.forEach(({ paramName, value }) => {
                if (!searchParams.getAll(paramName).includes(value)) {
                  searchParams.append(paramName, value);
                }
              });

              const previousParams = new URLSearchParams(window.location.search);
              ['q', 'sort_by'].forEach(key => {
                if (previousParams.has(key)) {
                  searchParams.set(key, previousParams.get(key));
                }
              });

              newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;

              productContainer.innerHTML = `
                <intersection-loader 
                  data-url="${newURL}"
                  data-section-id="plp-tiles-listing"
                  class="block w-full py-16 col-span-2 lg:col-span-3 loading relative"
                >${plpLoader}</intersection-loader>
              `;

              this.updateAppliedFiltersSection(newURL);
              this.classList.toggle('has-filters', activeValues.length > 0);
            break;
            case 'update-sorting':
              if (actionEl.value == 'none' || searchParams.toString().includes(actionEl.value)) return
              searchParams.set('sort_by', actionEl.value);
              newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
      
              productContainer.innerHTML = `
                <intersection-loader 
                  data-url="${newURL}"
                  data-section-id="plp-tiles-listing"
                  class="block w-full py-16 col-span-2 lg:col-span-3 loading relative"
                >${plpLoader}</intersection-loader>
              `;
              
              history.pushState({}, null, newURL);
            break;
            case 'pagination-next':
              searchParams.set('page', Number(page));
              newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
              actionEl.closest('[data-pagination-wrapper]')?.remove();
                            
              productContainer.innerHTML += `
                <intersection-loader 
                  data-url="${newURL}"
                  data-section-id="plp-tiles-listing"
                  class="block w-full py-16 col-span-2 lg:col-span-3 loading relative"
                >${plpLoader}</intersection-loader>
              `;
            break;
            default: break;
          }
        });
      });
    }
    updateAppliedFiltersSection(newURL) {
      const appliedFiltersContainer = this.querySelector('[data-applied-filters]');
      if (!appliedFiltersContainer) return;
    
      appliedFiltersContainer.innerHTML = `
        <intersection-loader 
          data-url="${newURL}"
          data-section-id="applied-filters"
          class=""
        >
        <ul class="flex gap-2">
          <li class="bg-sizeChartGray w-28 h-7 px-3 py-1"></li>
          <li class="bg-sizeChartGray w-28 h-7 px-3 py-1"></li>
          <li class="bg-sizeChartGray w-28 h-7 px-3 py-1"></li>
        </ul>
        </intersection-loader>
      `;
    
      history.pushState({}, null, newURL);
    }
    
  }
  
  customElements.define('product-listing', ProductListing);
}
